import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Constants from '../../../../model/AppConfiguration';
import { AppBar, Typography, withStyles } from 'material-ui';
import Tabs, { Tab } from 'material-ui/Tabs';
import TabStyles from './CalendarTabStyles';
import TabsStyles from './CalendarTabsStyles';
import CalendarMobile from '../../../../components/flights/calendarMobile/CalendarMobile';
import FlightsScreenController from '../../FlightsScreenController';
import FlightSeats from '../../../../components/flights/flightSeats/FlightSeats';
import CalendarLegend from '../../../../components/flights/calendarLegend/CalendarLegend';
import moment from 'moment';
import Dictionary from '../../../../model/Dictionary';
import PlaneIcon from '../../../../icons/PlaneIcon';
import ClassNames from 'classnames';
import ColorPalette from '../../../../components/styling/ColorPalette';
import StyledComponent from '../../../../components/styling/StyledComponent';
import '../../../routeTabs/RouteTabs.css';

function TabContainer (props) {
  return (
    <Typography
      component='div'
      style={{
        top: '60px',
        width: '100%',
        height: '100%',
        display: 'block',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = { children: PropTypes.node.isRequired };

class CalendarMobileTabs extends Component {
  generateTabName = (route, selectedTab, isRouteActive, isArrival) => {
    const { flights } = this.props;
    let departure = isArrival ? route.arrival.slice(0, 3) : route.departure.slice(0, 3);
    let arrival = isArrival ? route.departure.slice(0, 3) : route.arrival.slice(0, 3);
    let departureDate =
      flights[ 0 ] && flights[ 0 ].date ? flights[ 0 ].date : Dictionary.flights.selectDate;
    let arrivalDate =
      flights[ 1 ] && flights[ 1 ].date ? flights[ 1 ].date : Dictionary.flights.selectDate;
    let selectedDate = isArrival ? arrivalDate : departureDate;
    selectedDate = FlightsScreenController.formatDateLongMonthWithDay(selectedDate);

    return (
      <span className='tab-icon-text-wrapper'>
        <span className='route-name'>
          {departure}
          &nbsp;&nbsp;
          <PlaneIcon
            className={ClassNames({
              'plane-selected': isRouteActive,
              'plane-default': !isRouteActive,
            })}
          />&nbsp;
          {arrival}
          <div className='route-date'>{selectedDate}</div>
        </span>
      </span>
    );
  };

  render () {
    const {
      selectedRoute,
      selectedTrip,
      flights,
      selectDate,
      handleTabChange,
      selectedTab,
      departureFlight,
      arrivalFlight,
      classes,
    } = this.props;

    let currentlyActiveRoute = selectedRoute ? parseInt(selectedRoute.id, 10) - 1 : '';
    let isRouteActive = currentlyActiveRoute === selectedTab;
    let tab1 = this.generateTabName(selectedRoute, selectedTab, isRouteActive);
    let tab2 = this.generateTabName(selectedRoute, selectedTab, !isRouteActive, true);
    let isRoundTrip = selectedTrip && selectedTrip.id === Constants.flights.roundTrip;
    const StyledTabs = StyledComponent(Tabs)(TabsStyles);

    return (
      <div>
        <AppBar
          position='static'
          style={{
            backgroundColor: ColorPalette.navigationBgBlue,
            borderRadius: 0,
            width: '100%',
            boxShadow: 'none',
          }}
        >
          <StyledTabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor='none'
            textColor='primary'
            centered
            fullWidth
          >
            <Tab
              icon={tab1}
              classes={classes}
              style={{ minWidth: isRoundTrip ? 'inherit' : 'calc(100% - 5px)' }}
            />
            {isRoundTrip ? <Tab icon={tab2} classes={classes} /> : null}
          </StyledTabs>
        </AppBar>
        {flights.map((flight, index) => {
          if (
            index !== selectedTab ||
            (selectedTrip && selectedTrip.id === Constants.flights.oneWay && index > 0)
          ) {
            return null;
          }
          return (
            <TabContainer key={`calendar-mobile-tab-${flight.id}-${index}`}>
              <CalendarMobile
                routeId={`${selectedTab + 1}`}
                flightId={flight.id}
                selectDate={selectDate}
                selectedDate={flight.date}
                prefix={index === 0 ? 'departure' : 'arrival'}
                minDate={
                  flights[ index - 1 ] ?
                    flights[ index - 1 ].date :
                    moment(new Date()).format(Constants.DATE_FORMAT)
                }
                maxDate={
                  selectedTrip && selectedTrip.id === Constants.flights.oneWay ?
                    null :
                    flights[ index + 1 ] ? flights[ index + 1 ].date : null
                }
              />
              {departureFlight && index === 0 ? (
                <FlightSeats flightId={departureFlight.id} seats={departureFlight.text} />
              ) : null}

              {arrivalFlight && index === 1 ? (
                <FlightSeats flightId={arrivalFlight.id} seats={arrivalFlight.text} />
              ) : null}
              <CalendarLegend />
            </TabContainer>
          );
        })}
      </div>
    );
  }
}

CalendarMobileTabs.propTypes = {
  selectedRoute: PropTypes.object,
  selectedTrip: PropTypes.object,
  departureFlight: PropTypes.object,
  arrivalFlight: PropTypes.object,
  selectDate: PropTypes.func,
  flights: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(TabStyles)(CalendarMobileTabs);



// WEBPACK FOOTER //
// ./src/containers/flights/mobile/calendar/CalendarTabs.js